/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* eslint-disable no-return-assign */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-key */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Grid,
  Typography,
  Container,
  IconButton,
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
  Paper,
  InputBase,
  FormControl,
  Select,
  OutlinedInput,
  MenuItem,
} from '@mui/material';
import { Search } from 'lucide-react';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import GridOnIcon from '@mui/icons-material/GridOn';
import ViewListIcon from '@mui/icons-material/ViewList';
import { makeStyles } from '@mui/styles';
import LinearProgress from '@mui/material/LinearProgress';
import BookIcon from '@mui/icons-material/MenuBookOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Drawer from '@mui/material/Drawer';
import { useMobileRestriction } from '../../../hooks/useResponsive';
import UserCard from './UserCardB2B';
import PageHeader from '../../../components/PageHeader';
import CardSkeleton from '../../../components/Skeleton/cardSkeleton';
import Background from '../../../assets/logo/myCourseBackground.svg';
import ChatDialog from './ChatDialog';
import SatCard from '../../../components/cards/SatCardB2B';
import NeetCard from '../../../components/cards/NeetCardB2b';
import { EmptyModule } from '../../../store/reducer';

const ASSESSMENT_LABELS = {
  SAT: 'SAT Assessment',
  NEETAssessment: 'NEET Assessment',
  CLAT: 'CLAT Assessment',
  JEE: 'JEE Assessment',
};

const ASSESSMENT_CARD_MAP = {
  NEETAssessment: NeetCard,
};

const ASSESSMENT_TYPES = ['Full Test', 'Subject Test', 'Chapter Test'];

const getLabel = (type) => ASSESSMENT_LABELS[type] || `${type} Assessment`;
const getCardComponent = (type) => ASSESSMENT_CARD_MAP[type] || SatCard;

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowWidth;
};

export default function CourseList() {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const windowWidth = useWindowWidth();
  const { t } = useTranslation('translation');

  const [courseList, setCourseList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [groupedCourses, setGroupedCourses] = useState({});
  const [courseGroups, setCourseGroup] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [showSkeletons, setShowSkeletons] = useState(true);
  const [assessmentGroups, setAssessmentGroups] = useState({});
  const [activeFilters, setActiveFilters] = useState({});
  const [typeFilters, setTypeFilters] = useState({});  // NEW: assessment_type filter
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shouldTriggerDelayedClick, setShouldTriggerDelayedClick] = useState(false);

  const categoryRefs = useRef({});
  const assessmentRefs = useRef({});
  const isClickScrollingRef = useRef(false);

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const isMobile = useMediaQuery('(max-width:768px)');

  const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
  const pageNAme = useSelector((state) => state?.pageName || 'paid');
  const alldetails = useSelector((state) => state);

  let sidebarWidth;
  if (isLargeScreen) sidebarWidth = 280;
  else if (isMediumScreen) sidebarWidth = 250;
  else sidebarWidth = 220;

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250 },
    },
  };

  useEffect(() => {
    let timer;
    if (courseList.length === 0) {
      setShowSkeletons(true);
      timer = setTimeout(() => setShowSkeletons(false), 5000);
    } else {
      setShowSkeletons(false);
    }
    return () => clearTimeout(timer);
  }, [courseList]);

  useEffect(() => {
    if (!isMobile && mobileOpen) setMobileOpen(false);
  }, [isMobile]);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const observerCallback = (entries) => {
    if (isClickScrollingRef.current) return;
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const category = entry.target.dataset.category;
        setActiveCategory(category);
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    });
    Object.values(categoryRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });
    return () => observer.disconnect();
  }, []);


  const ASSESSMENT_SCROLL_MAP = [
    { keyword: 'NEET', refKey: 'NEETAssessment' },
    { keyword: 'SAT', refKey: 'SAT' },
    { keyword: 'JEE', refKey: 'JEEAssessment' },
    { keyword: 'CLAT', refKey: 'CLATAssessment' },
  ];

  useEffect(() => {
    const state = location?.state;
    if (!state || typeof state !== 'string') return;

    const match = ASSESSMENT_SCROLL_MAP.find(({ keyword }) => state.includes(keyword));
    if (!match) return;

    const { refKey } = match;

    const timer = setTimeout(() => {
      isClickScrollingRef.current = true;
      const ref = assessmentRefs.current[refKey];
      ref?.scrollIntoView({ behavior: 'auto', block: 'start' });
      setActiveCategory(getLabel(refKey));
      setTimeout(() => {
        isClickScrollingRef.current = false;
      }, 500);
    }, 100);

    return () => clearTimeout(timer);
  }, [location.state]);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo(0, 10);
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (categoryList.length === 0 && Object.keys(assessmentGroups).length === 0) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const cat = entry.target.dataset.category;
            if (cat && !isClickScrollingRef.current) setActiveCategory(cat);
          }
        });
      },
      { threshold: 0.1, rootMargin: '-10% 0px -35% 0px' }
    );
    categoryList.forEach((category) => {
      const el = categoryRefs.current[category];
      if (el) observer.observe(el);
    });
    Object.keys(assessmentGroups).forEach((type) => {
      const el = assessmentRefs.current[type];
      if (el) observer.observe(el);
    });
    return () => {
      categoryList.forEach((category) => {
        const el = categoryRefs.current[category];
        if (el) observer.unobserve(el);
      });
      Object.keys(assessmentGroups).forEach((type) => {
        const el = assessmentRefs.current[type];
        if (el) observer.unobserve(el);
      });
    };
  }, [categoryList, assessmentGroups, windowWidth]);

  localStorage.removeItem('expandedItem');
  localStorage.removeItem('subModuleExpandedItem');

  useEffect(() => {
    setLoading(true);
    let filteredCourses = alldetails?.courseListB2b || [];
    if (pageNAme === 'free') {
      filteredCourses = filteredCourses.filter((item) => item.is_free === true);
    } else {
      filteredCourses = filteredCourses.filter((item) => item.is_free === false);
    }
    setCourseList(filteredCourses);

    const categories = [...new Set(filteredCourses?.map((item) => item.category.description))];
    setCategoryList(categories);

    const coursesByCategory = {};
    filteredCourses?.forEach((course) => {
      const category = course.category.description;
      if (!coursesByCategory[category]) coursesByCategory[category] = [];
      coursesByCategory[category].push(course);
    });
    setGroupedCourses(coursesByCategory);

    const individualCourses = filteredCourses?.filter((item) => item.isBundle === false);
    const bundleCourses = filteredCourses?.filter((item) => item.isBundle);
    const grouped = Array.from(
      bundleCourses?.reduce(
        (m, o) => m.set(o.subscriptionPlanId, (m.get(o.subscriptionPlanId) || []).concat(o)),
        new Map()
      ).values()
    );
    setCourseGroup([[...individualCourses], ...grouped]);

    if (userRole === 'USER_DTC' && filteredCourses?.length === 0) {
      navigate('/auth/subscribe');
    }

    const groups = {};
    (alldetails?.SatListB2b || []).forEach((item) => {
      if (!groups[item.type]) groups[item.type] = [];
      groups[item.type].push(item);
    });
    setAssessmentGroups(groups);

    // Initialize status filters
    setActiveFilters((prev) => {
      const next = { ...prev };
      Object.keys(groups).forEach((t) => {
        if (!next[t]) next[t] = 'all';
      });
      return next;
    });

    // NEW: Initialize assessment_type filters
    setTypeFilters((prev) => {
      const next = { ...prev };
      Object.keys(groups).forEach((t) => {
        if (!next[t]) next[t] = 'all';
      });
      return next;
    });

    setLoading(false);
    setShouldTriggerDelayedClick(true);
  }, [alldetails?.courseListB2b, alldetails?.SatListB2b, pageNAme]);

  useEffect(async () => {
    const script = document.getElementById('zsiqscript');
    if (script) script.parentNode.removeChild(script);
  }, [pageNAme]);

  useEffect(() => {
    if (!loading && shouldTriggerDelayedClick && activeCategory) {
      const timer = setTimeout(() => {
        handleCategoryClick(activeCategory);
        setShouldTriggerDelayedClick(false);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [loading, shouldTriggerDelayedClick, activeCategory]);

  const handleCategoryClick = (category, isManualClick = false) => {
    if (isManualClick) isClickScrollingRef.current = true;
    const matchedType = Object.keys(assessmentGroups).find((t) => getLabel(t) === category);
    if (matchedType) {
      assessmentRefs.current[matchedType]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      categoryRefs.current[category]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    setActiveCategory(category);
    setTimeout(() => {
      isClickScrollingRef.current = false;
    }, 800);
  };

  const handleSearch = () => {
    if (!searchValue.trim()) return;
    const lowerInput = searchValue.trim().toLowerCase();
    const courseMatch = categoryList.find((cat) => cat.toLowerCase().includes(lowerInput));
    if (courseMatch) {
      setActiveCategory(courseMatch);
      categoryRefs.current[courseMatch]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const assessmentMatch = Object.keys(assessmentGroups).find(
      (type) =>
        type.toLowerCase().includes(lowerInput) ||
        getLabel(type).toLowerCase().includes(lowerInput)
    );
    if (assessmentMatch) {
      const label = getLabel(assessmentMatch);
      setActiveCategory(label);
      assessmentRefs.current[assessmentMatch]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    alert('Category not found');
  };

  const handleCardClickItem = (data) => {
    if (userRole === 'USER_DTC') {
      navigate(`/auth/course-details/${data.id}/${data.subscriptionPlanId || data.subscriptionplanid || ""}`, { state: data });
    } else {
      navigate(`/app/course-details/${data.id}/${data.subscriptionPlanId || data.subscriptionplanid || ""}`, { state: data });
    }
  };

  const handleChatOpen = () => setIsChatOpen(true);
  const handleChatClose = () => setIsChatOpen(false);

  function LinearProgressWithLabel({ value }) {
    return (
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '5px !important' }} mb={0.5}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress
              variant="determinate"
              value={value}
              sx={{
                backgroundColor: '#e3e3e3',
                '& .MuiLinearProgress-bar': { backgroundColor: '#52c28c' },
              }}
            />
          </Box>
          <Box sx={{ width: 'max-content' }}>
            <Typography variant="body2" sx={{ fontSize: '0.7rem' }}>
              {value}%
            </Typography>
          </Box>
        </Box>
        <Typography
          variant="body2"
          color={'#000'}
          sx={{ fontSize: '0.7rem', marginTop: '-8px' }}
        >
          Overall Progress
        </Typography>
      </Box>
    );
  }

  const ButtonGrp = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
      <IconButton>
        <Search fontSize="medium" style={{ color: '#BCBCBC' }} />
      </IconButton>
      <IconButton>
        <FilterAltIcon fontSize="medium" style={{ color: '#BCBCBC' }} />
      </IconButton>
      <IconButton>
        <GridOnIcon fontSize="medium" style={{ color: '#00B673' }} />
      </IconButton>
      <IconButton>
        <ViewListIcon fontSize="medium" style={{ color: '#BCBCBC' }} />
      </IconButton>
    </div>
  );

  const renderAssessmentSidebarItems = (mobile = false) => {
    if (pageNAme === 'free' || Object.keys(assessmentGroups).length === 0) return null;
    return (
      <>
        <Typography
          component="div"
          sx={{
            color: '#999',
            fontWeight: '600',
            fontSize: 14,
            mt: mobile ? 2 : 0,
            mb: 1,
            pl: mobile ? 0 : 2,
            display: mobile ? 'block' : 'grid',
            gridTemplateColumns: mobile ? undefined : 'auto 1fr',
            gap: mobile ? undefined : '1.5rem',
            alignItems: 'center',
          }}
        >
          ASSESSMENT
        </Typography>
        {Object.keys(assessmentGroups).map((type) => {
          const label = getLabel(type);
          const isActive = activeCategory === label;
          if (mobile) {
            return (
              <Box
                key={type}
                onClick={() => {
                  handleCategoryClick(label, true);
                  handleDrawerToggle();
                }}
                sx={{
                  p: 1.5,
                  borderRadius: '4px',
                  mb: 1,
                  color: isActive ? '#4d6da3' : '#666',
                  backgroundColor: isActive ? '#d1e0fa' : 'transparent',
                  fontWeight: isActive ? '600' : 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: '#f0f0f0' },
                }}
              >
                <BookIcon fontSize="small" sx={{ color: isActive ? '#4d6da3' : '#666', mr: 2 }} />
                {label}
              </Box>
            );
          }
          return (
            <ListItemButton
              key={type}
              onClick={() => handleCategoryClick(label, true)}
              selected={isActive}
              sx={{
                pl: 4,
                fontWeight: isActive ? '600' : 'normal',
                color: isActive ? '#ff7e4a' : '#999',
                '&.Mui-selected': {
                  bgcolor: '#5d7db4',
                  color: '#fff',
                  '&:hover': { bgcolor: '#5d7db4' },
                },
                '&:hover': { bgcolor: isActive ? '#fee9db' : '#f5f5f5' },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, marginRight: '10px' }}>
                <BookIcon fontSize="small" sx={{ color: isActive ? '#fff' : '#999' }} />
              </ListItemIcon>
              <ListItemText primary={label} primaryTypographyProps={{ fontSize: 13 }} />
            </ListItemButton>
          );
        })}
      </>
    );
  };

  const renderAssessmentSections = () => {
    if (pageNAme === 'free') return null;

    return (
      <>
        {Object.keys(assessmentGroups).map((type) => {
          const label = getLabel(type);
          const isActive = activeCategory === label;
          const items = assessmentGroups[type] || [];
          const filter = activeFilters[type] || 'all';
          const typeFilter = typeFilters[type] || 'all';
          const CardComponent = getCardComponent(type);

          const allStatuses = [...new Set(items.map((i) => i.status).filter(Boolean))];
          const hasFilters = allStatuses.length > 1;

          const statusFiltered = filter === 'all' ? items : items.filter((i) => i.status === filter);

          const typeCounts = ASSESSMENT_TYPES.reduce((acc, t) => {
            acc[t] = statusFiltered.filter((i) => i.assessment_type === t).length;
            return acc;
          }, {});

          const filtered =
            typeFilter === 'all'
              ? statusFiltered
              : statusFiltered.filter((i) => i.assessment_type === typeFilter);

          return (
            <Box
              key={type}
              ref={(el) => (assessmentRefs.current[type] = el)}
              data-category={label}
              sx={{ scrollMarginTop: '80px' }}
              className={classes.categorySection}
            >
              <Grid container spacing={isMobile ? 1 : 2} sx={{ width: '100%', margin: 0 }}>
                <Box
                  sx={{
                    backgroundColor: isActive ? '#345ca1' : '#fff',
                    border: isActive ? '1px solid #345ca1' : '1px solid #111',
                    borderRadius: '5px',
                    width: '100%',
                    margin: '35px 10px 15px',
                    padding: '10px 10px 10px 10px !important',
                    fontWeight: { md: '500', lg: '600' },
                    scrollMarginTop: '80px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 1,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: '13px', sm: '14px', md: '14px', lg: '16px' },
                      color: isActive ? '#fff' : '#000',
                    }}
                  >
                    {label}
                  </Typography>
                  {hasFilters && (
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <Select
                        value={filter}
                        onChange={(e) =>
                          setActiveFilters((prev) => ({ ...prev, [type]: e.target.value }))
                        }
                        input={<OutlinedInput />}
                        MenuProps={MenuProps}
                        sx={{
                          color: isActive ? '#fff' : '#333',
                          fontSize: 13,
                          '.MuiOutlinedInput-notchedOutline': {
                            borderColor: isActive ? 'rgba(255,255,255,0.6)' : '#bbb',
                          },
                          '.MuiSvgIcon-root': { color: isActive ? '#fff' : '#555' },
                          backgroundColor: 'transparent',
                        }}
                      >
                        <MenuItem value="all">All</MenuItem>
                        {allStatuses.map((s) => (
                          <MenuItem key={s} value={s}>
                            {s}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </Box>

                <div className="w-full px-3 mt-2 mb-3">
                  <div className="inline-flex items-center gap-1 bg-gray-100 rounded-xl p-1 border border-gray-200">
                    {[
                      { label: 'All', count: statusFiltered.length, value: 'all' },
                      ...ASSESSMENT_TYPES.map((aType) => ({
                        label: aType,
                        count: typeCounts[aType] || 0,
                        value: aType,
                      })),
                    ].map(({ label: tabLabel, count, value }) => {
                      const isSelected = typeFilter === value;
                      const isDisabled = value !== 'all' && count === 0;
                      return (
                        <button
                          key={value}
                          onClick={() => {
                            if (isDisabled) return;
                            setTypeFilters((prev) => ({
                              ...prev,
                              [type]: isSelected && value !== 'all' ? 'all' : value,
                            }));
                          }}
                          disabled={isDisabled}
                          className={[
                            'inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150 whitespace-nowrap border select-none',
                            isSelected
                              ? 'bg-white text-[#2d52a0] border-gray-200 shadow-sm'
                              : 'bg-transparent text-gray-500 border-transparent hover:bg-white/60 hover:text-gray-700',
                            isDisabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer',
                          ].join(' ')}
                        >
                          <span>{tabLabel}</span>
                          <span
                            className={[
                              'inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-md text-[11px] font-semibold',
                              isSelected
                                ? 'bg-[#dce8f8] text-[#2d52a0]'
                                : 'bg-black/10 text-gray-500',
                            ].join(' ')}
                          >
                            {count}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                </div>

                {filtered?.length > 0 ? (
                  filtered.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={`${type}-${index}`}>
                      <CardComponent comingFrom="B2B" data={item} />
                    </Grid>
                  ))
                ) : (
                  <Box sx={{ mt: 2, mb: 5, ml: 2, width: '100%' }}>
                    <Typography
                      style={{ textAlign: 'center' }}
                      variant="h6"
                      fontWeight="bold"
                      id="TitleName"
                    >
                      Sorry! No assessments are allotted to your account!
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Box>
          );
        })}

        {!loading &&
          courseList.length === 0 &&
          Object.keys(assessmentGroups).length === 0 && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '60vh',
                width: '100%',
                gap: 2,
                px: 3,
                textAlign: 'center',
              }}
            >
              <BookIcon sx={{ fontSize: 72, color: '#ccc' }} />
              <Typography variant="h5" fontWeight={600} color="#555">
                No Courses or Assessments Assigned
              </Typography>
              <Typography variant="body1" color="#999" sx={{ maxWidth: 420 }}>
                You don't have any courses or assessments assigned to your account yet.
                Please contact your administrator for access.
              </Typography>
            </Box>
          )}
      </>
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      {isMobile && (
        <Box
          sx={{
            position: 'fixed',
            top: 75,
            left: 10,
            zIndex: 1100,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{
              mr: 2,
              backgroundColor: '#f5f5f5',
              '&:hover': { backgroundColor: '#e0e0e0' },
            }}
          >
            <MenuIcon />
          </IconButton>
        </Box>
      )}

      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: 280,
              backgroundColor: '#fafafa',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 2,
              borderBottom: '1px solid #ddd',
            }}
          >
            <Typography variant="h6" sx={{ marginLeft: '12px' }}>
              Categories
            </Typography>
            <IconButton onClick={handleDrawerToggle}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box id="mobileSidebar" sx={{ p: 2 }}>
            <Typography
              component="div"
              sx={{ color: '#999', fontWeight: '600', fontSize: 14, mb: 1 }}
            >
              LEARN
            </Typography>
            {categoryList?.map((text) => (
              <Box
                key={text}
                onClick={() => {
                  handleCategoryClick(text, true);
                  handleDrawerToggle();
                }}
                sx={{
                  p: 1.5,
                  borderRadius: '4px',
                  mb: 1,
                  color: activeCategory === text ? '#4d6da3' : '#666',
                  backgroundColor: activeCategory === text ? '#d1e0fa' : 'transparent',
                  fontWeight: activeCategory === text ? '600' : 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: '#f0f0f0' },
                }}
              >
                <BookIcon
                  fontSize="small"
                  sx={{ color: activeCategory === text ? '#4d6da3' : '#666', mr: 2 }}
                />
                {text}
              </Box>
            ))}
            {process.env.REACT_APP_ENV === 'dev' &&
              <Box
                onClick={() => {
                  navigate(`${location.pathname.startsWith('/auth') ? '/auth' : '/app'}/e-books`);
                  handleDrawerToggle();
                }}
                sx={{
                  p: 1.5, borderRadius: '4px', mb: 1, color: '#666',
                  display: 'flex', alignItems: 'center', cursor: 'pointer',
                  '&:hover': { backgroundColor: '#f0f0f0' },
                }}
              >
                <BookIcon fontSize="small" sx={{ color: '#666', mr: 2 }} />
                E-Books
              </Box>}
            {renderAssessmentSidebarItems(true)}
          </Box>
        </Drawer>
      )}

      {!isMobile && (
        <Box
          id="sidePanelAsideB2B"
          sx={{
            width: sidebarWidth,
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            bgcolor: '#fafafa',
            borderRight: '1px solid #ddd',
            overflowY: 'auto',
            zIndex: 10,
            paddingTop: '60px',
            boxSizing: 'border-box',
          }}
        >
          <List
            component="nav"
            aria-labelledby="nested-list-subheader-2"
            subheader={
              <ListSubheader
                component="div"
                id="nestedListSubHeading"
                sx={{
                  bgcolor: 'transparent',
                  color: '#999',
                  fontWeight: '600',
                  fontSize: 14,
                  mt: 0,
                  mb: 1,
                  pl: 2,
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  gap: '1.5rem',
                  alignItems: 'center',
                  paddingRight: 0,
                }}
              >
                LEARN
              </ListSubheader>
            }
          >
            {categoryList?.map((text) => (
              <ListItemButton
                disableRipple
                key={text}
                onClick={() => handleCategoryClick(text, true)}
                selected={activeCategory === text}
                sx={{
                  pl: 4,
                  fontWeight: activeCategory === text ? '600' : 'normal',
                  color: activeCategory === text ? '#fff' : '#999',
                  lineHeight: '1.2',
                  '&.Mui-selected': {
                    bgcolor: '#5d7db4',
                    '&:hover': { bgcolor: '#5d7db4' },
                  },
                  '&:hover': {
                    bgcolor: activeCategory === text ? '#fee9db' : '#f5f5f5',
                  },
                }}
              >
                <ListItemIcon sx={{ minWidth: 36, marginRight: '10px' }}>
                  <BookIcon
                    fontSize="small"
                    sx={{ color: activeCategory === text ? '#fff' : '#999' }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{ fontSize: 13, lineHeight: '1.2' }}
                />
              </ListItemButton>
            ))}
          </List>

          {/* Cross-link to the E-Books library (same rail idea, own page) */}
       {process.env.REACT_APP_ENV === 'dev' &&
          <ListItemButton
            disableRipple
            onClick={() => navigate(`${location.pathname.startsWith('/auth') ? '/auth' : '/app'}/e-books`)}
            sx={{
              pl: 4, color: '#999', fontWeight: 'normal', lineHeight: '1.2',
              '&:hover': { bgcolor: '#f5f5f5' },
            }}
          >
            <ListItemIcon sx={{ minWidth: 36, marginRight: '10px' }}>
              <BookIcon fontSize="small" sx={{ color: '#999' }} />
            </ListItemIcon>
            <ListItemText primary="E-Books" primaryTypographyProps={{ fontSize: 13, lineHeight: '1.2' }} />
          </ListItemButton>}

          {renderAssessmentSidebarItems(false)}
        </Box>
      )}

      <Box
        sx={{
          flexGrow: 1,
          marginLeft: isMobile ? 0 : `${sidebarWidth}px`,
          width: isMobile ? '100%' : `calc(100% - ${sidebarWidth}px)`,
          height: isMobile ? 'calc(100vh - 60px)' : '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          boxSizing: 'border-box',
          paddingTop: isMobile ? '50px' : 0,
        }}
      >
        <PageHeader pageTitle="MycoursePageB2BUser" breadcrumbs={<ButtonGrp />} />
        <Container
          maxWidth={false}
          sx={{
            padding: isMobile ? '0 10px !important' : '0 !important',
            width: '100%',
            maxWidth: '100% !important',
          }}
        >
          <Grid container spacing={isMobile ? 1 : 2} sx={{ width: '100%', margin: 0 }}>
            {loading ? (
              <>
                {[1, 2, 3, 4, 5].map((_, idx) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={`skeleton-${idx}`}>
                    <CardSkeleton />
                  </Grid>
                ))}
              </>
            ) : (
              <>
                <Box
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'end',
                    marginRight: '10px',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: isMobile ? 'stretch' : 'center',
                    marginBottom: isMobile ? '15px' : '0',
                  }}
                >
                  <Paper
                    component="form"
                    sx={{
                      p: '0px 2px',
                      display: 'flex',
                      alignItems: 'center',
                      width: isMobile ? '100%' : 300,
                      marginTop: isMobile ? '15px' : '25px',
                      marginLeft: '15px',
                      borderRadius: '30px',
                      border: '1px solid #bbb',
                    }}
                  >
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      placeholder="Search By Category"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      inputProps={{ 'aria-label': 'search Category' }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleSearch();
                        }
                      }}
                    />
                    <IconButton
                      type="button"
                      sx={{ p: '10px' }}
                      aria-label="search"
                      onClick={handleSearch}
                    >
                      <Search sx={{ color: '#bbb' }} />
                    </IconButton>
                  </Paper>
                </Box>

                {categoryList?.map((text, index) => (
                  <React.Fragment key={`category-${text}`}>
                    <Box
                      ref={(el) => (categoryRefs.current[text] = el)}
                      sx={{
                        backgroundColor: activeCategory === text ? '#345ca1' : '#fff',
                        border:
                          activeCategory === text ? '1px solid #345ca1' : '1px solid #111',
                        color: '#fff',
                        borderRadius: '5px',
                        width: '100%',
                        margin: index === 0 ? '10px 10px 0px' : '35px 10px 0px',
                        padding: '10px !important',
                        fontWeight: { md: '500', lg: '600' },
                        scrollMarginTop: '80px',
                      }}
                      data-category={text}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          fontSize: { xs: '13px', sm: '14px', md: '17px', lg: '17px' },
                          color: activeCategory === text ? '#fff' : '#000',
                        }}
                      >
                        {text}
                      </Typography>
                    </Box>
                    {groupedCourses[text]?.map((course, cIndex) => (
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={cIndex}>
                        <UserCard
                          handleCardClick={() => handleCardClickItem(course)}
                          image={course?.coverageImage}
                          planStatus={course.planStatus}
                          title={course.title}
                          trial={course.isTrial}
                          subscribed={course.isSubscribed}
                          category={course.category}
                          logo={course.category.categoryImgUrl}
                          enrollDate={course.validFrom}
                          progress={<LinearProgressWithLabel value={course.completed} />}
                          data={course}
                        />
                      </Grid>
                    ))}
                  </React.Fragment>
                ))}

                {courseList?.length === 0 &&
                  showSkeletons &&
                  [1, 2, 3, 4, 5].map((_, idx) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={`skeleton-${idx}`}>
                      <CardSkeleton />
                    </Grid>
                  ))}
              </>
            )}
          </Grid>
          {renderAssessmentSections()}
        </Container>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles(() => ({
  coursediv: {
    height: '10rem',
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    marginTop: '4rem',
  },
  title: {
    padding: '4rem 0rem 0rem 0rem',
  },
  categorySection: {
    scrollMarginTop: '100px',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    minHeight: '60vh',
  },
}));